import React, { useState } from 'react';
import './SupportVisualisationEmbeddedApiTest.scss';
import { Button } from '@instinet-analytics/semantic-ui-components';
import { TextInput } from '@instinet-analytics/semantic-ui-components';
import { useServices } from 'app/hooks';
import { LayoutLoadedMessage } from 'embedded/api/out/messages/LayoutLoadedMessage';
import { v4 as uuid } from 'uuid';
import { ReloadRequiredMessage } from 'embedded/api/out/messages/ReloadRequiredMessage';
import { useSubscribers } from 'embedded/api/hooks/useSubscribers';
import { OutTopic } from 'embedded/api/out/OutTopic';

export default function SupportVisualisationEmbeddedApiTestOut() {
    const { embeddedApiService } = useServices();

    const [reason, setReason] = useState('');
    const [layoutName, setLayoutName] = useState('');

    const emitReloadRequired = () => {
        const message: ReloadRequiredMessage = {
            topic: 'RELOAD_REQUIRED',
            payload: {
                correlationId: uuid(),
                reason,
            },
        };
        embeddedApiService.send(message);
    };

    const emitLayoutLoaded = () => {
        const message: LayoutLoadedMessage = {
            topic: 'LAYOUT_LOADED',
            payload: {
                correlationId: uuid(),
                layoutName,
            },
        };
        embeddedApiService.send(message);
    };

    return (
        <div className="SupportVisualisationEmbeddedApiTestIn">
            <div className="topic">
                <h2>Reload Required</h2>
                <div className="form">
                    <div className="title">Reason: </div>
                    <TextInput onChange={setReason} value={reason} />
                </div>
                <Subscribers
                    topic={'RELOAD_REQUIRED'}
                    onClick={emitReloadRequired}
                />
            </div>
            <div className="topic">
                <h2>Layout Loaded</h2>
                <div className="form">
                    <div className="title">Layout Name: </div>
                    <TextInput onChange={setLayoutName} value={layoutName} />
                </div>
                <Subscribers topic="LAYOUT_LOADED" onClick={emitLayoutLoaded} />
            </div>
        </div>
    );

    function Subscribers(props: { topic: OutTopic; onClick: () => void }) {
        const { topic, onClick } = props;
        const subscribers = useSubscribers(topic);

        return (
            <div className="subscribers">
                <div className="title">Subscribers: </div>
                <div className="subs">
                    {subscribers.length === 0
                        ? 'None'
                        : subscribers.map((s) => (
                              <div key={s.uuid}>{s.name}</div>
                          ))}
                </div>
                <Button
                    primary
                    onClick={onClick}
                    disabled={subscribers.length === 0}
                >
                    Emit
                </Button>
            </div>
        );
    }
}
